type RenderWordsProps = {
  gameWords: string[];
  roundCount: number;
  cryptoKey: string;
  isGameStarted: boolean;
  winState:boolean;
};
const RenderWords = ({
  gameWords,
  roundCount,
  cryptoKey,
  isGameStarted,
  winState
}: RenderWordsProps) => {
  const wordArray = gameWords[roundCount].toUpperCase().split("");
  const lengthWidth = wordArray.length * 5;
  return (
    <div
      className="crypto-board-game-code-word"
      style={{
        width: lengthWidth + `vw`,
        gridTemplateColumns: `repeat(${wordArray.length}, 5vw)`,
      }}
    >
      {(isGameStarted &&!winState) &&
        wordArray.map((letter, index) => {
          const symbolIndex = cryptoKey.toUpperCase().indexOf(letter);

          return (
            <div key={index} className="crypto-code-cell" data-testid="crypto-cell">
              <div className={`crypto-symbol symbol-${symbolIndex}`}data-testid={`symbol-${symbolIndex}`} />
            </div>
          );
        })}
    </div>
  );
};
export default RenderWords;
